module.exports = __webpack_public_path__ + "static/bromo-romantis-43d245d949ae82e3a4b060bfcde2be12.png";